
import React from 'react';
import { Loader, RefreshCw } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { StaticImageBackground } from './StaticImageBackground';

interface AuthLoadingStateProps {
  onRetry: () => void;
}

export const AuthLoadingState: React.FC<AuthLoadingStateProps> = ({ onRetry }) => {
  return (
    <div className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-black">
      <StaticImageBackground />

      <div className="relative z-10 text-center max-w-md mx-auto p-6">
        <div className="mb-6">
          <Loader className="h-16 w-16 text-luxury-red mx-auto mb-4 animate-spin" />
          <h2 className="text-xl font-semibold text-white mb-2">Verificando autenticação...</h2>
          <p className="text-gray-400 mb-6">Aguarde um momento</p>
        </div>
        
        <Button 
          onClick={onRetry}
          variant="ghost"
          className="w-full text-gray-400 hover:text-white"
        >
          <RefreshCw className="h-4 w-4 mr-2" />
          Tentar novamente
        </Button>
      </div>
    </div>
  );
};

export default AuthLoadingState;
